import React, { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { Card, Form, Input, Button } from "antd";
import Loading from "../../fragments/Loading";
import styles from "./Auth.module.css";
import { userLogin, userGet, saveSession } from "../../utils";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

class Auth extends Component {
  constructor(props) {
    super(props);

    const pathname = window.location.pathname.replace("/", "");

    this.state = {
      state: pathname,
      loading: true,
      error: null
    };
  }

  /**
   * Component did mount
   */
  componentDidMount() {
    this.setState({
      loading: false,
    });

    // Clear query params
    const url = document.location.href;
    window.history.pushState({}, "", url.split("?")[0]);
  }

  /**
   * Handles form submission
   */
  handleSubmit = async (values, apiCall = userLogin) => {
    this.setState({ loading: true });

    // Validate email
    if (!values.email) {
      return this.setState({
        loading: false,
        formError: "email is required",
      });
    }

    // Validate password
    if (!values.password) {
      return this.setState({
        loading: false,
        formError: "password is required",
      });
    }

    try {
      const token = await apiCall(values.email, values.password);
      // Fetch user record and set session in cookie
      let user = await userGet(token.token);
      user = user.user;
      saveSession(user.id, user.email, token.token);

      window.location.replace("/");
    } catch (error) {
      console.log(error);
      if (error.message) {
        this.setState({
          formError: error.message,
          loading: false,
        });
      } else {
        this.setState({
          formError: "Sorry, something unknown went wrong.  Please try again.",
          loading: false,
        });
      }
      return;
    }
  }

  render() {
    return (
      <div className={styles.authWrapper}>
        <div className={styles.authCard}>
          <div className={styles.authLogo}>Brixture</div>

          {this.state.loading && (
            <div className={styles.containerLoading}>
              <Loading />
            </div>
          )}

          {!this.state.loading && (
            <Card>
              <Form {...layout} onFinish={(values) => this.handleSubmit(values)}>
                <Form.Item label="Email" name="email">
                  <Input />
                </Form.Item>
                <Form.Item label="Password" name="password">
                  <Input type="password" />
                </Form.Item>

                {this.state.formError && (
                  <div className={styles.formError}>
                    {this.state.formError}
                  </div>
                )}

                <Form.Item {...tailLayout}>
                  <Button type="primary" htmlType="submit">
                    Sign in
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Auth);
